import { render, staticRenderFns } from "./risk-assessment.vue?vue&type=template&id=867e92ca&scoped=true&"
import script from "./risk-assessment.vue?vue&type=script&lang=js&"
export * from "./risk-assessment.vue?vue&type=script&lang=js&"
import style0 from "./risk-assessment.vue?vue&type=style&index=0&id=867e92ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867e92ca",
  null
  
)

component.options.__file = "risk-assessment.vue"
export default component.exports